// extracted by mini-css-extract-plugin
export default {"chart":"chart_chart__BUj6O","xAxisTick":"chart_xAxisTick__Upyog"};